import React from "react";
import {Level, H1} from "NstyleComponents";
import * as PropTypes from 'prop-types';

export const AssignmentHeaderRow = ({title = ''}) => {
    return (
        <Level
            left={<div style={{display: 'flex', flexDirection: 'column'}}><H1>{title}</H1></div>}
            right={<div />}
            className="assignments__header-row"
        />
    );
};

AssignmentHeaderRow.propTypes = {
    title: PropTypes.string,
};

export default AssignmentHeaderRow;
